import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	genericErrorMessage: {
		id: 'servicedesk-sla-settings.services.jql-validation.generic-error-message',
		defaultMessage: 'Something has gone wrong. An error has occurred.',
		description: 'error message displayed when metric update is failed',
	},
});
